export const constant = {
	selector: {
		paginationHandler: 'data-select-paginator-handle',
		itemsPerPageParameterId: 'data-items-per-page-parameter-id',
	},
}
